import { render, staticRenderFns } from "./AddRecipeStoreItems.vue?vue&type=template&id=63cf40d2&"
import script from "./AddRecipeStoreItems.vue?vue&type=script&lang=js&"
export * from "./AddRecipeStoreItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports